<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import ImageHeader from 'image-header';

export default {
  mixins: [fandomBasicMixin],
  components: {
    ImageHeader
  },
  data: function () {
    return {
      isSidebarOpen: false,
      results: ""
    }
  },
  mounted() {
    Fandom.onEvent('grid-fixed:filters', this.handleUpdateFilters);
  },
  computed: {
    headerImage() {
      return this.content.image ? Fandom.getBackgroundUrl(this.content.image.url) : 'none';
    },
    filterBtnText() {
      return this.isSidebarOpen ? this.ft("globals.search.hide_filters") : this.ft("globals.search.show_filters");
    },
    isMobile() {
      return globalState.viewport.sm || globalState.viewport.xs || globalState.viewport.md;
    },
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
      if (this.isMobile) {
        disableBodyScroll(this.$refs["side-navbar"]);
      }
    },
    closeFullscreen() {
      this.isSidebarOpen = false;
      clearAllBodyScrollLocks();
    },
    handleUpdateFilters(count) {
      this.results = count;
    }
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="[contentType, {'secondary-navbar-present': !!content.navbar}, `${this.content.theme}-theme`]" 
    v-if="isContentVisibleToUser()" 
    class="position-relative" 
    page-search-component
  >
    <image-header :content="content"></image-header>
    <div class="wrapper" :class="{'active-side-nav': isSidebarOpen}">
      <div class="main-content w-100">
        <component class="h-100" :is="stripe.layout" :content="stripe" v-for="stripe in content.stripes" :key="stripe.$id" :opt-container-content="containerContent">
          <template #grid-header="{resultsCount}">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="header-content d-flex justify-content-between align-items-center pb-4">
                    <div class="h1 mb-0">{{ft("globals.search.results")}}<span v-if="resultsCount>=0" class="results">({{resultsCount}})</span></div>
                    <button 
                      class="btn shadow-none text-uppercase justify-content-center align-items-center d-flex px-3 py-2"
                      :class="!isSidebarOpen ? 'btn-outline-dark' : 'btn-dark'" 
                      @click="toggleSidebar"
                    >
                      <i class="fas fa-lg mr-2 fa-sliders-h-square"></i><span>{{filterBtnText}}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </component>
      </div>
      <nav ref="side-navbar" class="side-navbar" :class="{'fullscreen': isMobile}">
        <component 
          :is="stripe.layout"
          :content="stripe"
          v-for="stripe in content.sidebar"
          :key="`sidebar-${stripe.$id}`"
          :opt-container-content="containerContent"
        >
          <template #grid-filter-header>
            <div class="container-fluid grid-filter-header" v-if="isMobile">
              <div class="row">
                <div class="col-12 d-flex justify-content-between align-items-center py-2 px-4">
                  <span>{{ft("globals.search.filters_header")}}</span>
                  <i class="fal fa-times fa-lg" @click="closeFullscreen"></i>
                </div>
              </div>
            </div>
          </template>
          <template #grid-filter-footer>
            <div class="container-fluid grid-filter-footer" v-if="isMobile">
              <div class="row">
                <div class="col-12 d-flex justify-content-center py-3">
                  <button class="btn shadow-none text-uppercase btn-dark" @click="closeFullscreen">{{ft("globals.search.show_results", {results: results})}}</button>
                </div>
              </div>
            </div>
          </template>
        </component>
      </nav>
    </div>
  </div>
  
</template>

<style lang="scss">
[page-search-component] {
  $sidebar-width: 400px;
  $sidebar-mobile-header: 3rem;
  $sidebar-mobile-footer: 5.2rem;

  .wrapper {
    overflow-x: hidden;
    display: flex;
    position: relative;

    .side-navbar {
      padding: 0;
      top: 0;
      right: 0;
      width: $sidebar-width;
      display: flex;
      flex-direction: column;
      margin-right: - $sidebar-width;
      transition: all 0.5s ease-in-out;

      &.fullscreen {
        z-index: $zindex-sticky + 2;
        position: fixed;
        background: $white;
        width: 100vw;
        margin-right: -100vw;

        .grid-filter-header {
          border-bottom: 1px solid $gray-500;
        }
      }
    }

    &.active-side-nav {
      .side-navbar {
        margin-right: 0;
      }
    }

    .main-content {
      transition: margin 0.5s ease-in-out;

      .header-content {
        border-bottom: 1px solid $gray-500;
      }
    }
  }

  @include media-breakpoint-down(sm) {
    .main-content {
      .results {
        display: none;
      }
    }
  }

  @include media-breakpoint-down(md) {
    .side-navbar {
      height: 100vh;

      &.fullscreen {
        .grid-filter-header .row div:first-child {
          height: $sidebar-mobile-header;
        }

        .grid-filter-body {
          max-height: calc(100vh - #{$sidebar-mobile-header} - #{$sidebar-mobile-footer});
        }

        .grid-filter-footer .row div:first-child {
          height: $sidebar-mobile-footer;
        }
      }
    }
  }
}
</style>
